function gidForVariant(value) {
  if (!value) return '';
  return String(value).startsWith('gid://') ? String(value) : `gid://shopify/ProductVariant/${value}`;
}

function updatePersonalizeLinks(variantId) {
  document.querySelectorAll('[data-mystory-personalize]').forEach((link) => {
    const url = new URL(link.dataset.baseUrl || link.href, window.location.origin);
    url.searchParams.set('product_handle', link.dataset.productHandle || '');
    url.searchParams.set('product_id', link.dataset.productId || '');
    url.searchParams.set('variant_id', gidForVariant(variantId || link.dataset.variantId));
    link.href = `${url.pathname}${url.search}`;
  });
}

document.addEventListener('change', (event) => {
  const target = event.target;
  if (target instanceof HTMLInputElement && target.name === 'id') updatePersonalizeLinks(target.value);
});

document.addEventListener('DOMContentLoaded', () => {
  const formVariant = document.querySelector('form[action*="/cart/add"] [name="id"]');
  const urlVariant = new URL(window.location.href).searchParams.get('variant');
  updatePersonalizeLinks(urlVariant || formVariant?.value);
});
